<template lang="pug">
    .photo-album.container.content(v-if="(contents && contents.length) || edit")
        .column.preview-img-list.is-offset-1.is-10(
            v-if="contents && contents.length"
            ref="container"
            :style="{ height: `${layoutGeometry.containerHeight}px` }"
        )
            figure(
                v-for="(box, i) in boxes"
                :style="{ top: `${box.style.top}px`, left: `${box.style.left}px` }"
            )
                a(href="#" @click.prevent="$photoswipe.open($event, i, photoSwipeItems)")
                    AlbumImage(
                        class="preview-img-item"
                        :image="box.thumbnail"
                        :title="box.data.title"
                        :width="box.style.width"
                        :height="box.style.height"
                    )
                        button.delete(
                            v-if="edit"
                            @click.stop="$emit('change', section.id, section.contents[i].id, section.contents[i].images[0], 'delete')"
                        )
                        caption(v-if="box.data.title || striptags(box.data.text)")
                            h4 {{ box.data.title }}
                            div( v-html="box.data.text" )
        .upload(v-if="edit")
            .column.is-offset-1.is-10
                // @vdropzone-sending="newDocumentSending"
                // @vdropzone-sending-multiple="newDocumentSending"
                // @vdropzone-success="newDocumentUploaded"
                vue-dropzone(
                    ref="newImage"
                    id="new-photo-album-image"
                    :options="dropzoneOptions"
                    :use-font-awesome="true"
                    :auto-process-queue="true"
                    :upload-multiple="true"
                    :useCustomSlot="true"
                    @vdropzone-sending="newImageSending"
                    @vdropzone-sending-multiple="newImageSending"
                    @vdropzone-success="newImageUploaded"
                    @vdropzone-error="newImageUploadFailed"
                )
                    .dropzone-custom-content
                        i.fas.fa-cloud-upload-alt
                        h4.is-size-4.dropzone-custom-title(v-html="labels.title")
                        .subtitle(v-html="labels.sub_title")
</template>

<script>

import _ from 'lodash'
// import Vue from 'vue'
import striptags from 'striptags'
import justifiedLayout from 'justified-layout'
import vueDropzone from 'vue2-dropzone'

import store from '@/store'
import AlbumImage from './AlbumImage'

export default {
    name: 'PhotoAlbum',
    data() {
        return {
            config: {
                containerWidth: undefined,
                containerPadding: {
                    top: undefined,
                    right: undefined,
                    bottom: undefined,
                    left: undefined,
                },
                boxSpacing: 10,
                targetRowHeight: 320,
            },
            dropzoneOptions: {
                // url: 'https://httpbin.org/post',
                url: store.state.setup.uploadEndpoint,
                acceptedFiles: '.jpg,.jpeg,.png',
                maxFiles: 12,
                thumbnailWidth: 100,
                thumbnailHeight: 100,
                maxFilesize: 2,
                previewTemplate: this.previewTemplate(),
                timeout: 6 * 60 * 1000, // 6 minutes
            },
        }
    },
    props: {
        edit: {
            type: Boolean,
            default: false,
        },
        section: {
            type: Object,
            required: true,
        },
        // labels: {
        //     type: Object,
        //     default: () => {
        //         let labels = {
        //             title: 'Bilder hier ablegen',
        //             sub_title: 'oder <span class="href">hier klicken</span>',
        //         }

        //         return labels
        //     }
        // },
    },
    components: {
        AlbumImage,
        vueDropzone,
    },
    watch: {
        contents() {
            // console.log(window.scrollX, window.scrollY);
            const x = window.scrollX
            const y = window.scrollY
            setTimeout(() => {
                window.scrollTo(x, y)
                this.calculateDimansions() //resizes all images
            }, 0)
        },
    },
    computed: {
        labels() {
            let labels = {
                title: _.get(this.section, 'labels.title') || 'Bilder hier ablegen',
                sub_title: _.get(this.section, 'labels.sub_title') || 'oder <span class="href">hier klicken</span>',
            }

            return labels
        },
        contents() {
            let contents = this.section.contents || []
            return _.cloneDeep(contents).sort((a, b) => _.get(a, 'position', 0) - _.get(b, 'position', 0))
        },
        images() {
            let images = []

            this.contents.forEach(content => {
                const image = _.get(content, 'images.0')
                if (! image) return false

                image.title = content.title
                image.text = content.text

                images.push(image)
            })

            return images
        },
        ratios() {
            let ratios = []

            this.images.forEach(image => {
                const fz = _.get(image, 'pivot.z') || 1
                const w = _.get(image, 'pivot.w') || image.width / fz
                const h = _.get(image, 'pivot.h') || image.height / fz

                const ratio = w / h
                ratios.push(ratio)
            })

            return ratios
        },
        layoutGeometry() {
            return justifiedLayout(this.ratios, this.config)
        },
        boxes() {
            let boxes = []

            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')

            const calculateFit = (data, maxHeight) => {
                const pivot = data.pivot || {}
                let fit = _.get(pivot, 'fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1'

                // let { w, h, x, y, z } = pivot
                let { w, h, z } = pivot
                if (! z) z = 1

                let width = data.width / z
                let height = data.height / z
                let aspectRatio = width / height

                maxHeight = Math.min(maxHeight, height)

                if (w && h) {

                    aspectRatio = w / h

                    if (h > maxHeight) {
                        height = maxHeight
                    }

                    if (height * aspectRatio > data.width / z) {
                        height = width / aspectRatio
                    } else {
                        width = height * aspectRatio
                    }

                    fit = fit.replace(/w=([0-9]+\.?[0-9]*)/, `w=${width}`).replace(/h=([0-9]+\.?[0-9]*)/, `h=${height}`)

                } else if (! w && ! h) {
                    if (height > maxHeight) {
                        height = maxHeight
                        width = height * aspectRatio
                    }

                    fit += `&w=${width}`
                }

                let table = 'images'
                if (data.upload) table = 'uploads'

                return {
                    src: `${storageRoute}/${table}/${data.id}/${data.name}?${fit}`,
                    error: `${storageRoute}/${table}/${data.id}/${data.name}?${fit}&preview=greyscale`,
                    loading: `${storageRoute}/${table}/${data.id}/${data.name}?${fit}&preview=blur`,
                    width,
                    height,
                    aspectRatio,
                }
            }

            this.images.forEach((el, i) => {
                const style = this.layoutGeometry.boxes[i]

                let data, thumbnail, image
                data = el

                image = calculateFit(data, 1800)
                thumbnail = calculateFit(data, 500)

                boxes.push({ style, data, thumbnail, image })
            })

            return boxes
        },

        photoSwipeItems() {
            let items = []

            this.boxes.forEach(box => {
                const src = box.image.src
                const w = box.image.width
                const h = box.image.height

                let title = ''
                if (box.data.title) title += `<h4>${box.data.title}</h4>`
                if (this.striptags(box.data.text)) title += box.data.text

                items.push({ src, w, h, title })
            })

            return items
        }
    },
    methods: {
        striptags(value) {
            return _.trim(striptags(value))
        },
        previewTemplate() {
            return `
                <div class="dz-preview dz-file-preview">
                    <div class="dz-filename">
                        <span data-dz-name></span>
                    </div>
                    <div class="dz-size" data-dz-size></div>
                    <div class="dz-thumbnail">
                        <img data-dz-thumbnail />
                    </div>
                    <div class="dz-progress">
                        <span class="dz-upload" data-dz-uploadprogress></span>
                    </div>
                    <div class="dz-success-mark">
                        <i class="fas fa-check"></i>
                    </div>
                    <div class="dz-error-mark">
                        <i class="fas fa-times"></i>
                    </div>
                    <div class="dz-error-message">
                        <span data-dz-errormessage></span>
                    </div>
                </div>
            `;
        },
        newImageSending(file, xhr, formData) {
            formData.append('context[type]', 'content-image')
            formData.append('token', localStorage.getItem('member-token'))
            xhr.ontimeout = e => console.log('Server Timeout')
        },
        newImageUploaded(file, response) {
            this.$refs.newImage.removeFile(file)

            let image = response
            image.upload = true

            delete image.hash

            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')
            const table = 'uploads'

            let img = new Image()
            img.src = `${storageRoute}/${table}/${image.id}/${image.name}` // ?token=${localStorage.getItem('member-token')}
            img.onload = () => {
                image.width = img.width
                image.height = img.height

                this.$emit('change', this.section.id, undefined, image, 'add')
                setTimeout(() => this.calculateDimansions(), 0)
            }
        },
        newImageUploadFailed(file) {
            setTimeout(() => {
                this.$refs.newImage.removeFile(file)
            }, 2000)
        },
        calculateDimansions() {
            if (this.$refs.container) {
                const style = getComputedStyle(this.$refs.container)
                this.config.containerWidth = this.$refs.container.offsetWidth
                // this.config.containerWidth -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)

                this.config.containerPadding = {
                    top: parseInt(style.paddingTop),
                    right: parseInt(style.paddingRight),
                    bottom: parseInt(style.paddingBottom),
                    left: parseInt(style.paddingLeft),
                }
            }
        }
    },
    mounted() {
        window.addEventListener('resize', _.debounce(this.calculateDimansions, 100))
        this.calculateDimansions()
    }
}

</script>

<style lang="sass" scoped>

    @import '~@/assets/sass/variables';

    .photo-album.container.content .column
        position: relative
        figure
            background: #eeeeee
            border-radius: 4px
            position: absolute
            & > a
                & /deep/ > .preview-img-item
                    transition: transform .3s cubic-bezier(0, 0.9, 0.31, 1.04)
                    & > img
                        transition: box-shadow .3s cubic-bezier(0, 0.9, 0.31, 1.04)
                    & > caption
                        transition: background .3s cubic-bezier(0, 0.9, 0.31, 1.04), backdrop-filter .3s cubic-bezier(0, 0.9, 0.31, 1.04)
                &:hover /deep/ > .preview-img-item
                    position: relative
                    z-index: 2
                    transform: scale(1.015)
                    & > img
                        box-shadow: $box-shadow-3
                    & > caption
                        // opacity: 0.6
                        background: rgba(0,0,0,.3)
                        backdrop-filter: blur(2px)
            /deep/
                img
                    border-radius: 4px
                    display: block
                    &[lazy=loading]
                        box-shadow: none
                    &[lazy=loaded]
                        box-shadow: $box-shadow-2
                caption
                    font-size: .8rem
                    position: absolute
                    left: 0
                    bottom: 0
                    padding: 10px
                    right: 0
                    text-align: left
                    color: white
                    border-bottom-right-radius: 4px
                    border-bottom-left-radius: 4px
                    background: rgba(0,0,0,.8)
                    backdrop-filter: blur(6px)
                    h4
                        color: inherit
                        margin-bottom: 0
        .upload
            width: 100%
            & > .column
                padding-top: 0
                padding-bottom: 0
        .delete
            position: absolute
            top: 4px
            right: 4px
            z-index: 4
</style>
